//bms-custom-scripts.js

//hide language switcher on mobile and vise-verser
if($(window).width() < 768){
    var mob_lang_switcher = document.createElement('div');
    mob_lang_switcher.className='language-switcher'
    mob_lang_switcher.appendChild(document.querySelector('#ly-languages-switcher'));
    document.querySelector('.mobile-header').appendChild(mob_lang_switcher)
}

//loadImageTranslations function.

function loadImageTranslations(){
    var lang_selector = document.querySelector('select#ly-languages-switcher');
    var lang = lang_selector.options[lang_selector.selectedIndex].text;
    var img_src_attribute = "data-" + lang.toLowerCase() + "-src";
    var img_data_src_attribute = "data-" + lang.toLowerCase() + "-data-src";
    var img_srcset_attribute = "data-" + lang.toLowerCase() + "-srcset";
    var images = document.querySelectorAll("img[" + img_src_attribute + "]");

    for(var img=0; img<images.length; img++){
        var image = images[img];
        image.setAttribute('src', image.getAttribute(img_src_attribute));

        if(image.getAttribute(img_data_src_attribute))
            image.setAttribute('data-src', image.getAttribute(img_data_src_attribute));

        if(image.getAttribute(img_srcset_attribute))
            image.setAttribute('data-srcset', image.getAttribute(img_srcset_attribute));
    }
}

loadImageTranslations();

//code to increase the height of footer if the height of the page isn't hight enough to cover the entire screen height
$(function() {
    var $footer = $('.footer');
    var heightAdj = window.innerHeight - $footer.offset().top;

    if(heightAdj > $footer.height() ) {
        $footer.css('min-height', heightAdj);
    }
  });
